import { render, staticRenderFns } from "./staticSegmentDetail.vue?vue&type=template&id=71a9ad21&"
import script from "./staticSegmentDetail.vue?vue&type=script&lang=js&"
export * from "./staticSegmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./staticSegmentDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports